import Required from 'components/Required';
import { CreditCard, Landmark, Banknote } from 'lucide-react';
import React, { useEffect, useState, ChangeEvent } from 'react';
import {
  FormGroup,
  Row,
  Col,
  CardTitle,
  Label,
  Input,
} from 'reactstrap';
import { RematriculacionRequest } from 'types/Rematriculacion';

interface Props {
  data: Partial<RematriculacionRequest>;
  isLoading: boolean;
  formValidation: Partial<Record<keyof RematriculacionRequest, boolean>>;
  handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disableSend: boolean;
}

const StepThree = ({
  data,
  isLoading,
  formValidation,
  handleInputChange,
  disableSend,
}: Props) => {
  const optionsFormaPago = [
    {
      label: 'EFECTIVO POR MERCADO PAGO',
      icon: <Banknote size={26} />,
      value: 'efectivo',
    },
    {
      label: 'DÉBITO AUTOMÁTICO EN CUENTA BANCARIA CON CBU',
      icon: <Landmark size={26} />,
      value: 'bancaria',
    },
    {
      label: 'DÉBITO AUTOMÁTICO EN TARJETA DE CRÉDITO',
      icon: <CreditCard size={26} />,
      value: 'tarjeta',
    },
  ];

  const [selectedForma, setSelectedForma] = useState<string>();

  useEffect(() => {
    setSelectedForma(data.forma_pago);
  }, [data.matriculate_id]);

  const handleSelectPayment = (value: string) => {
    data.forma_pago = value;
    setSelectedForma(value);
  };

  return (
    <div style={{ padding: '0 10rem 1rem 10rem' }}>
      {/* Forma de pago */}
      <Col sm={12}>
        <CardTitle
          style={{
            fontSize: '1rem',
            fontWeight: 'normal',
          }}
        >Forma de pago de Matrícula <Required /></CardTitle>
        <CardTitle>
          Selecciona la modalidad con la que abonarás la matrícula.
        </CardTitle>
      </Col>

      <Row className='mt-3'>
        {optionsFormaPago.map(({ label, icon, value }) => {
          // const isActive = data.forma_pago === label;
          const isActive = selectedForma === value;
          return (
            <Col
              key={label}
              md='4'
              className='mb-2 mt-4 d-flex justify-content-center'
            >
              <div
                onClick={() => handleSelectPayment(value)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: '10px',
                  padding: '1rem 1rem',
                  borderRadius: '10px',
                  border: `2px solid ${isActive ? '#6f42c1' : 'gray'}`,
                  backgroundColor: isActive ? '#ccbaf1' : 'white',
                  color: isActive ? '#6f42c1' : '#0c0c0c',
                  fontWeight: 'bold',
                  cursor: isLoading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  minWidth: '100%',
                  height: 80,
                }}
              >
                {icon}
                <span
                  style={{
                    fontSize: 12,
                    textAlign: 'left',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    color: 'black',
                  }}
                >
                  {label}
                </span>
              </div>
            </Col>
          );
        })}
      </Row>
      { data.forma_pago === 'tarjeta' && (
        <Col sm={12} className='mt-4'>
          <CardTitle>Ingresá los datos de tu tarjeta de crédito</CardTitle>

          <FormGroup>
            <Row className='mt-3'>
              <Col md={6}>
                <Label
                  style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
                  for='tipo_tarjeta'
                >
                  Tarjetas Aceptadas <Required />
                </Label>
                <Input
                  id='tipo_tarjeta'
                  name='tipo_tarjeta'
                  type='select'
                  className='custom-select form-control'
                  value={data.tipo_tarjeta ?? ''}
                  invalid={formValidation.tipo_tarjeta === false}
                  onChange={handleInputChange}
                  disabled={isLoading || disableSend}
                  required
                >
                  <option value=''>
                    Seleccione un tipo...
                  </option>
                  <option value='VISA'>VISA</option>
                  <option value='MasterCard'>MasterCard</option>
                </Input>
              </Col>
              <Col md={6}>
                <Label
                  style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
                  for='numero_tarjeta_cbu'
                >
                  Número de tarjeta de crédito <Required />
                </Label>
                <Input
                  id='numero_tarjeta_cbu'
                  name='numero_tarjeta_cbu'
                  type='number'
                  value={data.numero_tarjeta_cbu ?? ''}
                  disabled={isLoading || disableSend}
                  invalid={formValidation.numero_tarjeta_cbu === false}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>
          </FormGroup>
        </Col>
      )}
      { data.forma_pago === 'bancaria' && (
        <Col sm={12} className='mt-4'>
          <CardTitle>Ingresá los datos de tu banco</CardTitle>

          <FormGroup>
            <Row className='mt-3'>
              <Col md={6}>
                <Label
                  style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}
                  for='numero_tarjeta_cbu'
                >
                  CBU <Required />
                </Label>
                <Input
                  id='numero_tarjeta_cbu'
                  name='numero_tarjeta_cbu'
                  type='number'
                  value={data.numero_tarjeta_cbu ?? ''}
                  disabled={isLoading || disableSend}
                  invalid={formValidation.numero_tarjeta_cbu === false}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Row>
          </FormGroup>
        </Col>
      )}
    </div>
  );
};

export default StepThree;
